//@flow
import { GetSettingsQuery, GetSettingsMessage, GetSettingsResponse } from '../../autogenerated/ZoomBridge';

export default class GetSettings {
  resetAll: boolean;
  constructor(resetAll: boolean = false) {
    this.resetAll = resetAll;
  }

  run(): Promise<GetSettingsResponse> {
    const query: GetSettingsQuery = new GetSettingsQuery();
    const msg: GetSettingsMessage = new GetSettingsMessage();
    msg.setResetAll(this.resetAll);
    msg.setFetchGlobalSettings(true);
    query.message = msg;
    return query.run();
  }
}
